module.exports = __webpack_public_path__ + "static/media/fruits-platter.6bee4958.jpg";